import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { isSerializedApiError } from 'src/app/utils/isSerializedApiError';

import { EventsState } from './events.interface';
import * as eventsThunk from './events.thunk';

export const getAllEventsBuilder = (
  builder: ActionReducerMapBuilder<EventsState>
) => {
  builder.addCase(eventsThunk.getAllEvents.pending, state => {
    state.status = 'PENDING';
    state.errorDetails = undefined;
  });

  builder.addCase(
    eventsThunk.getAllEvents.fulfilled,
    (state, { payload }: any) => {
      if (isSerializedApiError(payload)) {
        state.status = 'ERROR';
        state.errorDetails = payload;
        return;
      }

      state.events = payload.response;
      state.status = 'NORMAL';
    }
  );

  builder.addCase(
    eventsThunk.getAllEvents.rejected,
    (state, { payload }: any) => {
      console.log('ERROR EVENT THUNK', payload);
      if (isSerializedApiError(payload)) {
        state.status = 'ERROR';
        state.errorDetails = payload;
        return;
      }
      state.status = 'ERROR';
    }
  );
};
